import { aboutFeatures } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-center gap-3 mb-4">
          <span className="h-px w-12 bg-primary-500/50"></span>
          <span className="text-primary-500">◆</span>
          <span className="h-px w-12 bg-primary-500/50"></span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-primary-500/90">Our Story</span>
            <h2 className="font-heading text-4xl md:text-5xl font-semibold text-foreground-50 mt-4">
              About Bertie&rsquo;s
            </h2>
            <div className="flex items-center gap-3 my-6">
              <span className="h-px w-12 bg-primary-500/50"></span>
              <span className="text-primary-500">✦</span>
            </div>
            <p className="text-foreground-200/90 leading-relaxed text-base md:text-lg">
              We&rsquo;re crafting something extraordinary. Bertie&rsquo;s Restaurant &amp; Cocktails
              will be a destination where culinary artistry meets exceptional service, creating
              memorable experiences for every guest.
            </p>
            <p className="mt-5 text-foreground-200/70 leading-relaxed text-base">
              Rooted in Caribbean tradition and elevated by modern technique, our menu celebrates
              bold flavors, fresh ingredients, and the spirit of togetherness that defines island
              culture.
            </p>
          </div>

          <div className="flex flex-col gap-6">
            {aboutFeatures.map((feature, idx) => (
              <div
                key={feature.title}
                className="flex gap-5 items-start bg-background-100 border border-background-200/60 rounded-lg p-6 md:p-7"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-500 shrink-0">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-xl font-semibold text-foreground-50">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-200/70 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}